import { render } from "./AssignToPBSForm.vue?vue&type=template&id=54beee3b&scoped=true&ts=true"
import script from "./AssignToPBSForm.vue?vue&type=script&lang=ts"
export * from "./AssignToPBSForm.vue?vue&type=script&lang=ts"

import "./AssignToPBSForm.vue?vue&type=style&index=0&id=54beee3b&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54beee3b"]])

export default __exports__